// 微应用白名单
var whites = {
    // React: 'https://staticres.linhuiba.com/libs/react/17.0.2/react..production.min..js',
    // ReactDom: 'https://staticres.linhuiba.com/libs/react-dom/17.0.2/react-dom.production.min..js',
    // History: 'https://staticres.linhuiba.com/libs/history/5.2.0/history.production.min..js',
    // ReactRouter: 'https://staticres.linhuiba.com/libs/react-router/6.2.1/react-router.production.min..js',
    // ReactRouterDom: 'https://staticres.linhuiba.com/libs/react-router-dom/6.2.1/react-router-dom.production.min..js',
    // ReactRedux: 'https://staticres.linhuiba.com/libs/react-redux/7.2.6/react-redux.min.js',
    // axios: 'https://staticres.linhuiba.com/libs/axios/0.24.0/axios.min.js',
    bigdata: 'https://staticres.linhuiba.com/libs/lhb-bigdata/1.0.6/lhb-bigdata.js',
};
// 微应用生产环境白名单
var minWhites = {
// React: 'https://staticres.linhuiba.com/libs/react/17.0.2/react.development.js',
// ReactDom: 'https://staticres.linhuiba.com/libs/react-dom/17.0.2/react-dom.development.js',
// History: 'https://staticres.linhuiba.com/libs/history/5.2.0/history.development.js',
// ReactRouter: 'https://staticres.linhuiba.com/libs/react-router/6.2.1/react-router.development.js',
// ReactRouterDom: 'https://staticres.linhuiba.com/libs/react-router-dom/6.2.1/react-router-dom.development.js',
// ReactRedux: 'https://staticres.linhuiba.com/libs/react-redux/7.2.6/react-redux.js',
// axios: 'https://staticres.linhuiba.com/libs/axios/0.24.0/axios.js',
};
export { whites, minWhites, };
